export const environment = {
    production: false,
    urls: {
        api: 'https://sdp.n2g-iona-staging.net/v2/',
        auth: 'https://iona-test-staging.wla-backend.de/auth',
        wmsb: 'https://meter-readings-service.n2g-iona-staging.net/api',
        faq: 'https://iona-dev.wla-backend.de/faq/esc?showNav=true',
        rewriteUrl: 'https://eona-test.wla-backend.de/demo/',
    },
    isStaging: true,
};


